import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import de from "date-fns/locale/de";
import DatePicker from "react-datepicker";
import * as styles from "./Datepicker.module.scss";
import { Form } from "react-bootstrap";

registerLocale("de", de);
setDefaultLocale("de");

const Datepicker = (props) => {
	const {
		dateFormat = "dd.MM.yyyy",
		label,
		isYearPicker = false,
		field,
		form,
		maxDate,
		minDate,
		tight = false,
	} = props;

	const CustomInput = React.forwardRef((props, refs) => {
		return (
			<div className={styles["textfield"]} onClick={props.onClick}>
				<input type={"text"} className={"form-control"} value={props.value} readOnly={true} />
			</div>
		);
	});
	let className = classNames({
		[styles["datepicker"]]: true,
		[styles["year-picker"]]: isYearPicker,
		[styles["tight"]]: tight,
	});

	return (
		<div className={className}>
			{label && <Form.Label>{label}</Form.Label>}
			<div>
				<DatePicker
					popperPlacement={"bottom-start"}
					dateFormat={dateFormat}
					selected={field.value}
					customInput={<CustomInput />}
					showYearPicker={isYearPicker}
					showMonthYearDropdown={false}
					onChange={(date) => {
						form.setFieldValue(field.name, date);
					}}
					maxDate={maxDate}
					minDate={minDate}
				/>
			</div>
		</div>
	);
};

Datepicker.propTypes = {
	dateFormat: PropTypes.string,
	label: PropTypes.string,
	isYearPicker: PropTypes.bool,
};

export default Datepicker;
